type ClassName = string | false | undefined | null

export function cx(...classNames: ClassName[]) {
  return classNames.filter(Boolean).join(' ')
}
